import { useEffect, useMemo } from 'react';

export default function JsonLd({ data }: { data: Record<string, unknown> }) {
  const json = useMemo(() => JSON.stringify(data), [data]);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = json;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [json]);

  return null;
}